export const V2_DRAFT_SCHEMA_VERSION = 1

export function serializedByteLength (value) {
  const serialized = typeof value === 'string' ? value : JSON.stringify(value)
  if (typeof TextEncoder !== 'undefined') return new TextEncoder().encode(serialized).length
  return unescape(encodeURIComponent(serialized)).length
}

export function isQuotaExceededError (error) {
  return !!error && (error.name === 'QuotaExceededError' || error.name === 'NS_ERROR_DOM_QUOTA_REACHED' || error.code === 22 || error.code === 1014)
}

export function writeVersionedDraft (storage, key, payload, validate) {
  const envelope = {
    schema_version: V2_DRAFT_SCHEMA_VERSION,
    saved_at: new Date().toISOString(),
    payload
  }
  const serialized = JSON.stringify(envelope)
  try {
    storage.setItem(key, serialized)
    const readBack = storage.getItem(key)
    const parsed = readBack ? JSON.parse(readBack) : null
    if (!parsed || parsed.schema_version !== V2_DRAFT_SCHEMA_VERSION || (validate && !validate(parsed.payload))) {
      throw Object.assign(new Error('Draft read-back validation failed.'), { name: 'DraftVerificationError' })
    }
    return { ok: true, bytes: serializedByteLength(serialized), envelope: parsed }
  } catch (error) {
    return { ok: false, bytes: serializedByteLength(serialized), quotaExceeded: isQuotaExceededError(error), error }
  }
}

export function readVersionedDraft (storage, key, validate) {
  const raw = storage.getItem(key)
  if (!raw) return { ok: false, missing: true, bytes: 0 }
  try {
    const envelope = JSON.parse(raw)
    if (!envelope || envelope.schema_version !== V2_DRAFT_SCHEMA_VERSION || (validate && !validate(envelope.payload))) {
      return { ok: false, incompatible: true, bytes: serializedByteLength(raw) }
    }
    return { ok: true, payload: envelope.payload, bytes: serializedByteLength(raw), envelope }
  } catch (error) {
    return { ok: false, malformed: true, bytes: serializedByteLength(raw), error }
  }
}

export function storageInventory (storage, keys) {
  return (keys || []).map(key => {
    const value = storage.getItem(key)
    return { key, bytes: value ? serializedByteLength(value) : 0, present: value !== null }
  })
}

export function stripEphemeralPreviewUrls (value) {
  const copy = JSON.parse(JSON.stringify(value))
  const visit = candidate => {
    if (!candidate || typeof candidate !== 'object') return
    Object.keys(candidate).forEach(key => {
      const item = candidate[key]
      if (typeof item === 'string' && (key === 'artwork_preview_url' || key === 'thumbnail_url' || key === 'file_url')) {
        if (/^blob:/i.test(item) || /^data:/i.test(item) || /[?&](X-Amz-|Signature=|token=)/i.test(item)) candidate[key] = ''
      } else if (item && typeof item === 'object') visit(item)
    })
  }
  visit(copy)
  return copy
}
